import { Component, OnInit, ViewChild, HostListener, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { ProjectsRest } from '../projects.rest';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjectListRow, ProjectType } from '../projects.model';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';
import { GridMainFilter, GoupedColumn, GroupFunction, SelectionMode, GridSelection, SortedColumn } from '../../core/shared/grid/grid.model';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { GridParamsRestorable } from '../../core/services/grid-params-restoring/grid-params-restoring.model';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { ProjectService } from '../projects.service';
import { INgxSelectOption } from 'ngx-select-ex';

@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html'
})
export class ProjectsListComponent extends GridSelection implements OnInit, AfterViewInit, HasPermissions, GridParamsRestorable {
  previousMainFilters: any;
  readonly detailsPath: string = '';
  readonly detailsPaths: string[] = ['/projects/project', '/orders/order', '/consultations/consultation', '/services/service'];
  
  @ViewChild(GridComponent) grid: GridComponent;
  private path: string;
  public viewEnable = true;
  private projectTypes: ObjectToSelect[];
  private projectType: number;
  private projectManagers: ObjectToSelect[];
  private projectManager: number;
  private states: ObjectToSelect[];
  private state: number;
  private isRestoredMainFilter: boolean = false;
  public projectFiltersDisabled = false;
  public mainFilter: GridMainFilter[];
  public type: ProjectType;
  public initialFilters: any;
  public initialPageNumber: number = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public permissions: Permissions;
  public editedItemId: number;
  public projectTypeName: string = '/';
  private otherProjectType: ObjectToSelect = {
    name: 'Inne',
    id: 0,
    guid: ''
  };

  public hideToggles: boolean;
  public expanded: boolean;

  private headers = [
    { displayName: 'Numer', propertyName: 'numberString', propertyType: 'string' },
    { displayName: 'Numer obcy', propertyName: 'foreignNumber', propertyType: 'string' },
    { displayName: 'Kontrahent', propertyName: 'customerCode', propertyType: 'string' },
    { displayName: 'Płatnik', propertyName: 'receiverCode', propertyType: 'string' },
    { displayName: 'Menadżer projektu', propertyName: 'projectManager', propertyType: 'string' },
    { displayName: 'Data startowa', propertyName: 'startDate', propertyType: 'date', },
    { displayName: 'Data końcowa', propertyName: 'endDate', propertyType: 'date' },
    { displayName: 'Status', propertyName: 'stateTranslation', propertyType: 'string' },
    { displayName: 'Opis skrócony', propertyName: 'shortDescription', propertyType: 'string' }
  ];

  constructor(
    private projectRest: ProjectsRest,
    private router: Router,
    private route: ActivatedRoute,
    private permissionService: PermissionsService,
    private gridParamsRestoringService: GridParamsRestoringService,
    private spinnerService: SpinnerService,
    private projectService: ProjectService
  ) {
    super();
    this.onResize();
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions("Project");
    this.type = this.route.snapshot.data.type;
    if (this.type !== ProjectType.Project) {
      this.projectFiltersDisabled = true;
    }

    this.mainFilter = new Array();
    this.isRestoredMainFilter = this.tryRestoreFiltersAndPage();
    this.setProjectsType();

    this.getProjectTypes();
    this.getProjectManagers();
    this.getStates();

    this.path = `api/projects/grid`;
  }

  ngAfterViewInit() {
    this._grid = this.grid;
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  public getProjectTypes() {
    const action = this.projectRest.getProjectTypes;
    action.call(this.projectRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.projectTypes = result;

        this.projectTypes.push(this.otherProjectType);
      }
    });
  }

  private getDetailsPath() {
    switch (this.type) {
      case ProjectType.Project:
        return this.detailsPath;
      case ProjectType.Order:
        return "/orders/order";
      case ProjectType.Service:
        return "/services/service";
      case ProjectType.Consultations:
        return "/consultations/consultation";
      default:
        return this.detailsPath;
    }
  }

  private setProjectsType() {
    switch (this.type) {
      case ProjectType.Order: {
        this.lockProjectType('ZLC');
        break;
      }
      case ProjectType.Service: {
        this.lockProjectType('UMS');
        break;
      }
      case ProjectType.Consultations: {
        this.lockProjectType('KON');
        break;
      }
    }
  }

  private lockProjectType(value: string) {
    this.clearFilter('ProjectTypeName');
    this.mainFilter.push({ internalName: 'ProjectTypeName', value: value });

    this.projectTypeName = '/' + value;
  }

  public getProjectManagers() {
    const action = this.projectRest.getProjectManagers;
    action.call(this.projectRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.projectManagers = result;
      }
    });
  }

  public getStates() {
    const action = this.projectRest.getStates;
    action.call(this.projectRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.states = result;
        const active = Object.assign( new ObjectToSelect(), {
          id: 0,
          name: 'Aktywne',
        });
        this.states.unshift(active);
      }
    });
  }

  private clearFilter(internalName: string) {
    this.mainFilter.forEach((item, index) => {
      if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
    });
  }

  private setFilter(internalName: string, value: any) {
    if (internalName === 'ProjectTypeName') {
      value = this.projectTypes.find(x => x.id === value).name;
    }
    this.clearFilter(internalName);
    this.mainFilter.push({ internalName: internalName, value: value });
  }

  private filter() {
    if (this.type === ProjectType.Project) {
      this.clearFilter('ProjectTypeName');
      if (this.projectType != null) {
        this.setFilter('ProjectTypeName', this.projectType);
      }
    }

    this.clearFilter('StateId');
    if (this.state != null) {
      this.setFilter('StateId', this.state);
    }

    this.clearFilter('ProjectManager');
    if (this.projectManager != null) {
      this.setFilter('ProjectManager', this.projectManager);
    }

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  private clearFilters() {
    if ((this.projectType != null && this.type === ProjectType.Project) || this.state != null || this.projectManager != null) {
      if (this.type === ProjectType.Project) {
        this.projectType = undefined;
        this.clearFilter('ProjectTypeName');
      }

      this.projectManager = undefined;
      this.clearFilter('ProjectManager');

      this.state = undefined;
      this.clearFilter('StateId');

      this.grid.mainFilter = this.mainFilter;
      this.grid.refreshData();
    }
  }

  private onRowEdit(row: ProjectListRow) {
    this.projectService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id, this.type);
    switch (this.type) {
      case ProjectType.Project:
        this.router.navigate(['../projects/project', row.numberString], { queryParams: { id: row.id, projectType: this.type }, relativeTo: this.route });
        break;
      case ProjectType.Order:
        this.router.navigate(['../orders/order', row.numberString], { queryParams: { id: row.id, projectType: this.type }, relativeTo: this.route });
        break;
      case ProjectType.Consultations:
        this.router.navigate(['../consultations/consultation', row.numberString], { queryParams: { id: row.id, projectType: this.type }, relativeTo: this.route });
        break;
      case ProjectType.Service:
        this.router.navigate(['../services/service', row.numberString], { queryParams: { id: row.id, projectType: this.type }, relativeTo: this.route });
        break;
      default:
        this.router.navigate(['../projects/project', row.numberString], { queryParams: { id: row.id, projectType: this.type }, relativeTo: this.route });
        break;
    }
  }

  private onRowAdd() {
    this.projectService.complete();
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, undefined, this.type);
    switch (this.type) {
      case ProjectType.Project:
        this.router.navigate(['../projects/project', "new"], { queryParams: { id: 0, projectType: this.type }, relativeTo: this.route });
        break;
      case ProjectType.Order:
        this.router.navigate(['../orders/order', "new"], { queryParams: { id: 0, projectType: this.type }, relativeTo: this.route });
        break;
      case ProjectType.Consultations:
        this.router.navigate(['../consultations/consultation', "new"], { queryParams: { id: 0, projectType: this.type }, relativeTo: this.route });
        break;
      case ProjectType.Service:
        this.router.navigate(['../services/service', "new"], { queryParams: { id: 0, projectType: this.type }, relativeTo: this.route });
        break;
      default:
        this.router.navigate(['../projects/project', "new"], { queryParams: { id: 0, projectType: this.type }, relativeTo: this.route });
        break;
    }
  }

  private onRowDelete(row: ProjectListRow) {
    let buttons = {
      yes: { text: "Tak", value: "yes" },
      no: { text: "Nie", value: "no" }
    }

    let message = `Czy na pewno usunąć projekt ${row.numberString}`;
    sweetAlert(message, {
      buttons: buttons
    }).then((value) => {
      switch (value) {
        case "yes":
          this.projectRest.checkHasProjectSteps(row.id).subscribe((hasSteps: boolean) => {
            if (hasSteps) {
              let message = `Projekt posiada etapy. Czy na pewno chcesz usunąć?`;
              sweetAlert(message, {
                buttons: buttons
              }).then((value) => {
                switch (value) {
                  case "yes":
                    this.deleteProject(row);
                    break;
                }
              });
            } else {
              this.deleteProject(row);
            }
          });
          break;
      }
    });
  }

  private deleteProject(row: ProjectListRow) {
    this.projectRest.deleteProject(row.id).subscribe((result: boolean) => {
      if (result) {
        sweetAlert({ text: `Usunięto projekt ${row.numberString}` });
        this._grid.refreshData(false);
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 769) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }

  private tryRestoreFiltersAndPage(): boolean {
    let previousGridParams = this.gridParamsRestoringService.getPreviousProjectsGridParams(this.detailsPaths, this.type);
    if (!previousGridParams) {
      return false;
    }
    //console.log('previousGridParams:', previousGridParams);

    this.initialFilters = previousGridParams.initialFilters;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;

    return true;
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }

  private setFiltersFromRestoredData() {
    const projectTypeName = this.findFilter('ProjectTypeName');
    let projectType = null;
    if (projectTypeName) {
      projectType = this.projectTypes.find(x => x.name === projectTypeName).id;
      this.projectType = projectType;
    }

    const projectManager = this.findFilter('ProjectManager');
    this.projectManager = projectManager != null ? parseInt(projectManager) : null;

    const stateId = this.findFilter('StateId');
    this.state = stateId != null ? parseInt(stateId) : null;
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }
}
